<div class="modal-content">
  <div class="modal-header bg-tertiary">
    <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">Consent mode</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body text-center">
    <fieldset class="border border-2 border-dark-subtle mb-3 p-3 rounded-4">
      <legend class="float-none px-3 w-auto">Consent mode type</legend>

      <div class="row">
        <div class="col-6">
          <label><input [(ngModel)]="type" [ngModelOptions]="{standalone: true}" name="type" value="checkbox" class="me-3" type="radio"/>Checkbox</label>
        </div>

        <div class="col-6">
          <label><input [(ngModel)]="type" [ngModelOptions]="{standalone: true}" name="type" value="text" class="me-3" type="radio"/>Text</label>
        </div>
      </div>
    </fieldset>

    @if (type === 'checkbox') {
      <fieldset class="border border-2 border-dark-subtle my-3 p-3 rounded-4">
        <legend class="float-none px-3 w-auto">Config</legend>
        <div class="row text-start">
          <div class="col-6">
            <app-input-switch [(ngModel)]="checkbox.mandatory" [ngModelOptions]="{standalone: true}">Mandatory</app-input-switch>
          </div>
          <div class="col-6">
            <app-input-switch [(ngModel)]="checkbox.alreadyChecked" [ngModelOptions]="{standalone: true}">Already checked</app-input-switch>
          </div>
        </div>
      </fieldset>
    }

    @if (type === 'text') {
      <fieldset class="border border-2 border-dark-subtle my-3 p-3 rounded-4">
        <legend class="float-none px-3 w-auto">Text placement</legend>
        <div class="row">
          <div class="col-6">
            <label><input [(ngModel)]="text.placement" [ngModelOptions]="{standalone: true}" name="placement" value="up" class="me-3" type="radio"/>Above submit button</label>
          </div>
          <div class="col-6">
            <label><input [(ngModel)]="text.placement" [ngModelOptions]="{standalone: true}" name="placement" value="down" class="me-3" type="radio"/>Under submit button</label>
          </div>
        </div>
      </fieldset>
    }
  </div>

  <div class="modal-footer bg-tertiary">
    <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>

    <button (click)="submit()" type="button" class="btn btn-primary fw-bold">Create</button>
  </div>
</div>
